import http from './http'

//  查询所有启用的CMS模块
export function getAllCmsModel () {
  return http({
    url: '/api/cms/openwebsite/findAllCmsModel',
    method: 'get'
  })
}

export function getByNoticeId (noticeId) {
  return http({
    url: `/api/cms/openwebsite/findNoticeByNoticeId/${noticeId}`,
    method: 'get'
  })
}

// 查询所有启用的CMS配置信息
export function getCmsConfig () {
  return http({
    url: `/api/cms/openwebsite/findCmsConfigInfo`,
    method: 'get'
  })
}

// 查询所有启用的CMS通知
export function getCmsNotice () {
  return http({
    url: `/api/cms/openwebsite/findAllCmsNotice`,
    method: 'get'
  })
}

// 查询所有启用的CMS通知
export function getCmsNoticedetails (noticeId) {
  return http({
    url: `/api/cms/openwebsite/findNoticeByNoticeId/${noticeId}`,
    method: 'get'
  })
}

// 根据fileType查询指定类型的通用文件   下载
export function getCommonFile (fileType) {
  return http({
    url: `/api/cms/openwebsite/findCommonFileByFileType/${fileType}`,
    method: 'get'
  })
}

// 根据fileType查询指定类型的通用文件   下载
export function getCommonFileByFileType (params) {
  return http({
    url: `/api/cms/openwebsite/pageFindCommonFileByFileType`,
    method: 'get',
    params
  })
}

// 根据fileType查询指定类型的通用文件   下载
export function getCommonSearch (params) {
  return http({
    url: `/api/cms/openwebsite/findChannelItem`,
    method: 'get',
    params
  })
}

// 采集签名二维码
export function getCollectSignQrCode () {
  return http({
    url: `/api/cms/openwebsite/findCommonFileByFileType/116`,
    method: 'get',
    loading: false
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js